import React, { Component } from "react";
import GroupTitle from "../group-title/order-list-group-title";
import ListRow from "./order-list-list-row";
import { connect } from "react-redux";
import _ from "lodash";
import { injectIntl } from "react-intl";
import "./order-list-list.scss";
import { getOrderId } from "../../helper-order-list";
import Collapse from "@material-ui/core/Collapse";

class OrderListGroup extends Component {
    state = { showList: true };

    renderGroupTitle = () => {
        const data = this.props.title;
        const show = this.state.showList;
        return (
            <div onClick={() => this.setState({ showList: !show })}>
                <GroupTitle {...data} show={show} />
            </div>
        );
    };

    renderGroupList = () => {
        const list = this.props.list;
        return (
            <Collapse in={this.state.showList}>
                {list.map((order) => (
                    <ListRow key={getOrderId(order)} order={order} />
                ))}
            </Collapse>
        );
    };

    render() {
        return (
            <div className={this.props.key}>
                {this.renderGroupTitle()}
                {this.renderGroupList()}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    lan: _.get(state, "settings.lan", "en"),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(OrderListGroup));
